import type { ReactNode } from "react";

interface SectionHeadingProps {
  kicker: string;
  title: ReactNode;
  desc?: ReactNode;
  align?: "center" | "left";
  tone?: "light" | "dark";
}

export default function SectionHeading({
  kicker,
  title,
  desc,
  align = "center",
  tone = "dark",
}: SectionHeadingProps) {
  const isCenter = align === "center";
  return (
    <div className={`${isCenter ? "text-center mx-auto" : "text-left"} max-w-2xl`}>
      <span
        className={`inline-flex items-center gap-2 rounded-full px-4 py-1.5 text-sm font-medium ${
          tone === "dark"
            ? "bg-primary-100 text-primary-700"
            : "bg-accent-100 text-accent-800"
        }`}
      >
        <i className="ri-flashlight-fill text-primary-500" />
        {kicker}
      </span>
      <h2 className="mt-4 text-2xl md:text-4xl font-bold tracking-tight text-foreground-950">
        {title}
      </h2>
      {desc ? (
        <p className="mt-4 text-sm md:text-base leading-7 text-foreground-600">{desc}</p>
      ) : null}
    </div>
  );
}